import React from 'react';
import { CartProvider } from './contexts/CartContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProductGrid } from './components/ProductGrid';
import { Footer } from './components/Footer';
export function App() {
  return <CartProvider data-id="element-0">
      <div className="min-h-screen bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <Hero data-id="element-3" />
        <ProductGrid data-id="element-4" />
        <Footer data-id="element-5" />
      </div>
    </CartProvider>;
}